import {ZapleczeApi} from "../../../ZapleczeApi.ts";
import Profile from "../../../Model/Profile.ts";
import {EpidActive} from "../model/EpidActive.ts";
import {EpidStatus} from "../model/EpidStatus.ts";
import {EpidPublicon4} from "../model/EpidPublicon4.ts";
import {EpidPublicon8} from "../model/EpidPublicon8.ts";

export class EpidConfig extends ZapleczeApi {

    constructor(token: string, profile: Profile) {
        super(token, profile);
    }

    public async patchActive(active: EpidActive): Promise<EpidStatus> {
        const url = this.getUrl() + '/api/v1/epid/status/active';
        try {
            return this.patch<EpidStatus>(url, active);
        } catch (error) {
            console.error('Error fetching epid config:', error);
            throw error;
        }
    }

    public async patchPublicon4(publicon4: EpidPublicon4): Promise<EpidStatus> {
        const url = this.getUrl() + '/api/v1/epid/status/publicon4';
        try {
            return this.patch<EpidStatus>(url, publicon4);
        } catch (error) {
            console.error('Error fetching epid config:', error);
            throw error;
        }
    }

    public async patchPublicon8(publicon8: EpidPublicon8): Promise<EpidStatus> {
        const url = this.getUrl() + '/api/v1/epid/status/publicon8';
        try {
            return this.patch<EpidStatus>(url, publicon8);
        } catch (error) {
            console.error('Error fetching epid config:', error);
            throw error;
        }
    }
}